import React from 'react'
import CourseStats from './content/CourseStats'
import EnrolledUsers from '../../ReportingGroup/CourseReport/EnrolledUsers'
import Modal from '../../../../common/modal/Modal'
import { useCourseReport } from '../../ReportingGroup/context/CourseReportContext'
import Icons from '../../../../common/icons/Icons'
import MicroModal from 'micromodal'

const CourseDetails = ({data}) => {

    MicroModal.init()

    const { selectedCourse } = useCourseReport()

    return (
        <Modal 
            modalId={`msync-course-report-course-container`} 
            buttonTitle={''} 
            modalHeading={selectedCourse.course ?? ''}
            classNames={'msync-table-button'} 
            containerClassNames={'msync-course-details'}
        >
            <main className="msync-modal__body msync-modal__body--has-table msync-reporting__detail">
                <CourseStats />
                {
                    selectedCourse && (
                        <EnrolledUsers props={data} />
                    )
                }
            </main>
        </Modal>
    )
}

export default CourseDetails